import React from 'react';
import { brands } from '../data/mock';

const BrandsSection = () => {
  return (
    <section id="brands" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-sm font-semibold text-[#2563eb] bg-[#2563eb]/10 px-4 py-1.5 rounded-full mb-4">
            Authorized Dealer
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1e1919] mb-4">
            Our Trusted Brands
          </h2>
          <p className="text-[#736c64] max-w-2xl mx-auto">
            We partner with industry-leading brands to bring you the best electronics and accessories with full warranty and support.
          </p>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 lg:gap-8">
          {brands.map((brand, index) => (
            <div
              key={brand.id}
              className="group relative bg-[#f7f5f2] rounded-xl p-6 lg:p-8 flex items-center justify-center hover:bg-white hover:shadow-lg transition-all duration-300 cursor-pointer border border-transparent hover:border-[#2563eb]/20"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex flex-col items-center gap-3">
                <div className="h-16 lg:h-20 flex items-center justify-center filter grayscale group-hover:grayscale-0 transition-all duration-300 opacity-70 group-hover:opacity-100">
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="max-h-full max-w-[140px] object-contain"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="hidden items-center justify-center text-lg font-bold text-[#2563eb]">
                    {brand.name}
                  </div>
                </div>
                <span className="text-xs font-medium text-[#736c64] group-hover:text-[#2563eb] transition-colors">
                  {brand.name}
                </span>
              </div>
              
              {/* Hover Indicator */}
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-[#2563eb] group-hover:w-1/2 transition-all duration-300"></div>
            </div>
          ))}
        </div>

        {/* Canon Pixma Zone Badge */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-[#f7f5f2] px-6 py-3 rounded-full border border-[#2563eb]/20">
            <span className="w-2 h-2 rounded-full bg-[#e11d48]"></span>
            <span className="text-sm text-[#736c64] font-medium">
              Official <span className="text-[#1e1919] font-semibold">Canon Pixma Zone</span> • Genuine Products with Warranty
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
